import React, { useEffect } from 'react';
import { dspTimeout } from 'fmc-sdk';
import DspExpiredView from './DspExpiredView';

import useFeature from 'hooks/useFeature';
import useFmcHost from 'hooks/useFmcHost';
import { useDispatch } from 'react-redux';
import { resetInstantCredit } from 'state/resetInstantCredit';

const DspExpired: React.FC = props => {
  const { isEnabled } = useFeature();
  const fmcDispatch = useFmcHost();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetInstantCredit());
  }, [dispatch]);

  useEffect(() => {
    fmcDispatch(dspTimeout());
  }, [fmcDispatch]);

  return (
    <DspExpiredView {...props} canRetrieveDsp={isEnabled('dspRetrieval')} />
  );
};

export default DspExpired;
